<div [formGroup]="form" class="mb-6 animate-fade-in" [style.padding-left.px]="level * 20">
  <div class="bg-card p-6 rounded-2xl shadow-sm border border-gray-100">
    <!-- Question Title -->
    <h3 class="text-xl font-semibold text-foreground mb-2">
      {{ question.question }}
      <span *ngIf="question.is_required" class="text-red-500">*</span>
    </h3>
    <p *ngIf="question.question_description" class="text-sm text-foreground-secondary mb-4">
      {{ question.question_description }}
    </p>

    <!-- Question Control -->
    <div class="w-full">
      <!-- Special Template: BMI Calculation -->
      <!-- <div *ngIf="question.template_type === QuestionTemplate.BmiCalculation" class="space-y-4">
        <div class="grid grid-cols-2 gap-4">
          <div class="flex flex-col gap-2">
            <label class="text-sm font-medium text-gray-600">Height (cm)</label>
            <p-inputnumber [(ngModel)]="height" (onInput)="calculateBMI()" placeholder="e.g. 5 ft " [min]="0" class="w-full"></p-inputnumber>
          </div>
          <div class="flex flex-col gap-2">
            <label class="text-sm font-medium text-gray-600">Weight (kg)</label>
            <p-inputnumber [(ngModel)]="weight" (onInput)="calculateBMI()" placeholder="e.g. 70 Kg " [min]="0" class="w-full"></p-inputnumber>
          </div>
        </div>
        <div *ngIf="bmiValue" class="p-4 bg-gray-50 rounded-xl flex items-center justify-between border border-gray-100">
          <div>
            <span class="text-sm text-gray-500 uppercase tracking-wider font-semibold">Your BMI</span>
            <div class="text-2xl font-bold">{{ bmiValue }}</div>
          </div>
          <div class="text-right">
            <span class="text-sm text-gray-500 uppercase tracking-wider font-semibold">Category</span>
            <div class="text-lg font-bold" [ngClass]="bmiColorClass">{{ bmiCategory }}</div>
          </div>
        </div>
        <input type="hidden" [formControlName]="question.id">
      </div> -->
      <div *ngIf="question.template_type === QuestionTemplate.BmiCalculation" class="space-y-6">
        <!-- Inputs -->
        <div class="grid md:grid-cols-2 grid-cols-1 gap-6">
          <!-- Height in cm -->
          <div class="flex flex-col gap-2">
            <label class="text-sm font-semibold text-gray-700">Height (cm)</label>
            <p-inputnumber
              [(ngModel)]="height"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="calculateBMI()"
              placeholder="e.g. 170"
              [min]="0"
              [disabled]="disableHeight"
              class="w-full"
            >
            </p-inputnumber>
          </div>

          <!-- Weight in KG -->
          <div class="flex flex-col gap-2">
            <label class="text-sm font-semibold text-gray-700">Weight (Kg)</label>
            <p-inputnumber
              [(ngModel)]="weight"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="calculateBMI()"
              placeholder="e.g. 70"
              [min]="0"
              class="w-full"
            >
            </p-inputnumber>
          </div>
        </div>

        <!-- Result Card -->
        <div
          *ngIf="bmiValue"
          class="p-6 rounded-2xl border shadow-sm flex justify-between items-center"
          [ngClass]="bmiBackgroundClass"
        >
          <div>
            <div class="text-sm text-gray-500 uppercase font-semibold tracking-wide">Your BMI</div>
            <div class="text-3xl font-bold mt-1">
              {{ bmiValue }}
            </div>
          </div>

          <div class="text-right">
            <div class="text-sm text-gray-500 uppercase font-semibold tracking-wide">Category</div>
            <div class="text-lg font-bold mt-1" [ngClass]="bmiColorClass">
              {{ bmiCategory }}
            </div>
          </div>
        </div>

        <!-- BMI Legend -->
        <div class="grid grid-cols-4 gap-3 text-sm mt-4">
          <div class="p-3 rounded-lg bg-blue-50 text-blue-700 font-medium text-center">
            Underweight <br />
            <span class="text-xs">&lt; 18.5</span>
          </div>

          <div class="p-3 rounded-lg bg-green-50 text-green-700 font-medium text-center">
            Normal <br />
            <span class="text-xs">18.5 – 24.9</span>
          </div>

          <div class="p-3 rounded-lg bg-yellow-50 text-yellow-700 font-medium text-center">
            Overweight <br />
            <span class="text-xs">25 – 29.9</span>
          </div>

          <div class="p-3 rounded-lg bg-red-50 text-red-700 font-medium text-center">
            Obese <br />
            <span class="text-xs">30+</span>
          </div>
        </div>

        <input type="hidden" [formControlName]="question.id" />
      </div>

      <!-- Special Template: Sleep Input -->
      <div *ngIf="question.template_type === QuestionTemplate.Sleep_Input" class="py-4">
        <div class="flex flex-col items-center gap-6 w-full max-w-[500px] mx-auto">
          <div
            class="w-full bg-transparent flex flex-col items-center gap-4 transition-opacity duration-300"
            [class.opacity-40]="noFixedSleepTime"
            [class.pointer-events-none]="noFixedSleepTime"
          >
            <div class="text-center">
              <h4 class="text-2xl font-bold text-gray-800 mb-2">Sleep Cycle</h4>
            </div>

            <!-- Circular Slider Area -->
            <div
              class="relative flex items-center justify-center my-4"
              [style.width.px]="circleSize"
              [style.height.px]="circleSize"
              (mousedown)="onMouseDown($event)"
              (mousemove)="onMouseMove($event)"
              (mouseup)="onMouseUp()"
              (mouseleave)="onMouseUp()"
              (touchstart)="onTouchStart($event)"
              (touchmove)="onTouchMove($event)"
              (touchend)="onTouchEnd()"
              (touchcancel)="onTouchEnd()"
            >
              <!-- Background Ring -->
              <svg
                [attr.width]="circleSize"
                [attr.height]="circleSize"
                class="absolute inset-0 overflow-visible"
              >
                <circle
                  [attr.cx]="circleSize / 2"
                  [attr.cy]="circleSize / 2"
                  [attr.r]="radius"
                  fill="none"
                  stroke="#E5E7EB"
                  [attr.stroke-width]="strokeWidth"
                ></circle>

                <!-- Active Arc -->
                <path
                  [attr.d]="getArcPath()"
                  fill="none"
                  [attr.stroke]="tertiaryColor2"
                  [attr.stroke-width]="strokeWidth - 8"
                  stroke-linecap="round"
                ></path>

                <!-- Inner White Circle -->
                <circle
                  [attr.cx]="circleSize / 2"
                  [attr.cy]="circleSize / 2"
                  [attr.r]="radius - strokeWidth / 2 - 2"
                  fill="white"
                  filter="drop-shadow(0px 2px 4px rgba(0,0,0,0.1))"
                ></circle>

                <!-- Clock Face Text/Markers -->
                <g class="clock-face">
                  <text
                    [attr.x]="circleSize / 2"
                    [attr.y]="circleSize / 2 - radius + 55"
                    text-anchor="middle"
                    font-size="12"
                    font-weight="700"
                    fill="#374151"
                  >
                    12AM
                  </text>
                  <text
                    [attr.x]="circleSize / 2"
                    [attr.y]="circleSize / 2 + radius - 45"
                    text-anchor="middle"
                    font-size="12"
                    font-weight="700"
                    fill="#374151"
                  >
                    12PM
                  </text>
                  <text
                    [attr.x]="circleSize / 2 - radius + 55"
                    [attr.y]="circleSize / 2 + 4"
                    text-anchor="middle"
                    font-size="12"
                    font-weight="700"
                    fill="#374151"
                  >
                    6PM
                  </text>
                  <text
                    [attr.x]="circleSize / 2 + radius - 55"
                    [attr.y]="circleSize / 2 + 4"
                    text-anchor="middle"
                    font-size="12"
                    font-weight="700"
                    fill="#374151"
                  >
                    6AM
                  </text>

                  <text
                    [attr.x]="circleSize / 2 + (radius - 50) * 0.5"
                    [attr.y]="circleSize / 2 - (radius - 50) * 0.866 + 4"
                    text-anchor="middle"
                    font-size="10"
                    font-weight="600"
                    fill="#6B7280"
                  >
                    2
                  </text>
                  <text
                    [attr.x]="circleSize / 2 + (radius - 50) * 0.866"
                    [attr.y]="circleSize / 2 - (radius - 50) * 0.5 + 4"
                    text-anchor="middle"
                    font-size="10"
                    font-weight="600"
                    fill="#6B7280"
                  >
                    4
                  </text>
                  <text
                    [attr.x]="circleSize / 2 + (radius - 50) * 0.866"
                    [attr.y]="circleSize / 2 + (radius - 50) * 0.5 + 4"
                    text-anchor="middle"
                    font-size="10"
                    font-weight="600"
                    fill="#6B7280"
                  >
                    8
                  </text>
                  <text
                    [attr.x]="circleSize / 2 + (radius - 50) * 0.5"
                    [attr.y]="circleSize / 2 + (radius - 50) * 0.866 + 4"
                    text-anchor="middle"
                    font-size="10"
                    font-weight="600"
                    fill="#6B7280"
                  >
                    10
                  </text>

                  <text
                    [attr.x]="circleSize / 2 - (radius - 50) * 0.5"
                    [attr.y]="circleSize / 2 + (radius - 50) * 0.866 + 4"
                    text-anchor="middle"
                    font-size="10"
                    font-weight="600"
                    fill="#6B7280"
                  >
                    2
                  </text>
                  <text
                    [attr.x]="circleSize / 2 - (radius - 50) * 0.866"
                    [attr.y]="circleSize / 2 + (radius - 50) * 0.5 + 4"
                    text-anchor="middle"
                    font-size="10"
                    font-weight="600"
                    fill="#6B7280"
                  >
                    4
                  </text>
                  <text
                    [attr.x]="circleSize / 2 - (radius - 50) * 0.866"
                    [attr.y]="circleSize / 2 - (radius - 50) * 0.5 + 4"
                    text-anchor="middle"
                    font-size="10"
                    font-weight="600"
                    fill="#6B7280"
                  >
                    8
                  </text>
                  <text
                    [attr.x]="circleSize / 2 - (radius - 50) * 0.5"
                    [attr.y]="circleSize / 2 - (radius - 50) * 0.866 + 4"
                    text-anchor="middle"
                    font-size="10"
                    font-weight="600"
                    fill="#6B7280"
                  >
                    10
                  </text>

                  <!-- Ticks -->
                  <ng-container *ngFor="let tick of getClockTicks()">
                    <line
                      [attr.x1]="tick.x1"
                      [attr.y1]="tick.y1"
                      [attr.x2]="tick.x2"
                      [attr.y2]="tick.y2"
                      [attr.stroke]="tick.isMain ? '#9CA3AF' : '#D1D5DB'"
                      [attr.stroke-width]="tick.isMain ? 2 : 1"
                      stroke-linecap="round"
                    ></line>
                  </ng-container>
                </g>

                <!-- Center Icons -->
                <!-- Moon -->
                <path
                  d="M 160 110 A 8 8 0 1 0 166 122 A 10 10 0 1 1 160 110"
                  [attr.transform]="
                    'translate(' + (circleSize / 2 - 160) + ', ' + (circleSize / 2 - 160) + ')'
                  "
                  fill="#60A5FA"
                />
                <!-- Sun -->
                <circle
                  [attr.cx]="circleSize / 2"
                  [attr.cy]="circleSize / 2 + 40"
                  r="6"
                  fill="#FBBF24"
                />
                <path
                  *ngFor="let ray of getSunRays()"
                  [attr.d]="ray"
                  stroke="#FBBF24"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>

              <!-- Start Handle (Bedtime) -->
              <div
                class="absolute w-10 h-10 -ml-5 -mt-5 bg-white rounded-full flex items-center justify-center cursor-pointer select-none"
                [style.left.px]="getHandleX(startAngle)"
                [style.top.px]="getHandleY(startAngle)"
                [style.box-shadow]="
                  isDraggingStart
                    ? '0 0 15px rgba(255, 152, 0, 0.4), 0 2px 4px rgba(0,0,0,0.1)'
                    : '0 2px 4px rgba(0,0,0,0.15)'
                "
              >
                <!-- Custom Primary Color Icon -->
                <i class="pi pi-bell text-green-500 font-bold"></i>
              </div>

              <!-- End Handle (Wake Up) -->
              <div
                class="absolute w-10 h-10 -ml-5 -mt-5 bg-white rounded-full flex items-center justify-center cursor-pointer select-none"
                [style.left.px]="getHandleX(endAngle)"
                [style.top.px]="getHandleY(endAngle)"
                [style.box-shadow]="
                  isDraggingEnd
                    ? '0 0 15px rgba(255, 152, 0, 0.4), 0 2px 4px rgba(0,0,0,0.1)'
                    : '0 2px 4px rgba(0,0,0,0.15)'
                "
              >
                <span class="text-orange-500 font-bold" style="font-size: 16px"
                  >z<sup style="font-size: 10px">z</sup><sup style="font-size: 7px">z</sup></span
                >
              </div>
            </div>

            <!-- Sleep Summary Message -->
            <div
              *ngIf="sleepDuration && !noFixedSleepTime"
              class="flex items-center gap-3 animate-slide-up mt-2"
            >
              <i class="pi pi-moon text-orange-500 text-xl"></i>
              <div class="flex items-center gap-2">
                <span class="text-sm font-medium text-gray-500">Sleep Duration:</span>
                <span class="text-lg font-bold text-red-500">{{ sleepDuration }}</span>
              </div>
            </div>

            <div class="flex items-center gap-2 text-gray-400 mt-2">
              <i class="pi pi-info-circle"></i>
              <span class="text-sm">Drag the slider to adjust</span>
            </div>
          </div>

          <!-- I don't have a fixed time Button -->
          <button
            type="button"
            (click)="toggleNoFixedSleepTime()"
            class="w-full max-w-[400px] px-6 py-4 rounded-full border border-orange-500 font-bold transition-all flex items-center justify-center gap-3"
            [ngClass]="
              noFixedSleepTime
                ? 'bg-orange-500 text-white shadow-lg shadow-orange-500/30'
                : 'bg-transparent text-orange-500 hover:bg-orange-50'
            "
          >
            <i class="pi" [ngClass]="noFixedSleepTime ? 'pi-check' : 'pi-times'"></i>
            I don't have a fixed time
          </button>
        </div>
        <input type="hidden" [formControlName]="question.id" />
      </div>

      <!-- Layout: Grid (Supports Single & Multi) -->
      <div
        *ngIf="question.template_type === QuestionTemplate.Grid"
        class="grid grid-cols-1 sm:grid-cols-2 gap-4"
      >
        <div
          *ngFor="let option of question.questionOptions"
          (click)="toggleOption(option.value)"
          [class.border-blue-500]="isOptionSelected(option.value)"
          [class.bg-blue-50]="isOptionSelected(option.value)"
          class="p-4 border rounded-xl cursor-pointer hover:border-blue-300 transition-all flex items-center gap-3"
        >
          <p-radiobutton
            *ngIf="question.question_type === QuestionType.Single_Choice"
            [name]="question.id"
            [value]="option.value"
            [formControlName]="question.id"
            (click)="$event.stopPropagation()"
          ></p-radiobutton>
          <p-checkbox
            *ngIf="question.question_type === QuestionType.Multi_Choice"
            [name]="question.id"
            [value]="option.value"
            [formControlName]="question.id"
            (click)="$event.stopPropagation()"
          ></p-checkbox>

          <div
            *ngIf="option.icon_image"
            class="text-2xl w-10 h-10 flex items-center justify-center bg-gray-50 rounded-lg"
          >
            {{ getUnicodeIcon(option.icon_image) }}
          </div>

          <div class="flex flex-col">
            <span class="font-medium text-foreground">{{ option.value }}</span>
            <span *ngIf="option.description" class="text-xs text-gray-500">{{
              option.description
            }}</span>
          </div>
        </div>
      </div>

      <!-- Layout: List View (Supports Single & Multi) -->
      <div
        *ngIf="question.template_type === QuestionTemplate.List_View"
        class="flex flex-col gap-3"
      >
        <div *ngFor="let option of question.questionOptions" class="flex items-center gap-3">
          <p-radiobutton
            *ngIf="question.question_type === QuestionType.Single_Choice"
            [name]="question.id"
            [value]="option.value"
            [formControlName]="question.id"
            [id]="option.id"
          ></p-radiobutton>
          <p-checkbox
            *ngIf="question.question_type === QuestionType.Multi_Choice"
            [name]="question.id"
            [value]="option.value"
            [formControlName]="question.id"
            [id]="option.id"
          ></p-checkbox>
          <div *ngIf="option.icon_image" class="text-xl mr-1">
            {{ getUnicodeIcon(option.icon_image) }}
          </div>
          <label [for]="option.id" class="cursor-pointer font-medium text-foreground">{{
            option.value
          }}</label>
        </div>
      </div>

      <!-- Layout: Chip Choice (Supports Single & Multi) -->
      <div
        *ngIf="question.template_type === QuestionTemplate.Chip_Choice"
        class="flex flex-wrap gap-2"
      >
        <div
          *ngFor="let option of question.questionOptions"
          (click)="toggleOption(option.value)"
          [class.bg-blue-600]="isOptionSelected(option.value)"
          [class.text-white]="isOptionSelected(option.value)"
          [class.border-blue-600]="isOptionSelected(option.value)"
          class="px-4 py-2 rounded-full border border-gray-200 cursor-pointer hover:bg-gray-50 transition-colors text-sm font-medium flex items-center gap-2"
        >
          <span *ngIf="option.icon_image">{{ getUnicodeIcon(option.icon_image) }}</span>
          {{ option.value }}
        </div>
      </div>

      <!-- Layout: Yes No (Explicit Template) -->
      <div *ngIf="question.template_type === QuestionTemplate.Yes_No" class="flex gap-4">
        <p-selectbutton
          [options]="[
            { label: 'Yes', value: 'Yes' },
            { label: 'No', value: 'No' },
          ]"
          [formControlName]="question.id"
        ></p-selectbutton>
      </div>

      <!-- Special Template: Full Body Image (3 positions) -->
      <div
        *ngIf="question.template_type === QuestionTemplate.FullBodyImage"
        class="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-4"
      >
        <div class="flex flex-col gap-3">
          <span class="text-xs font-bold text-gray-500 uppercase text-center">Front View</span>
          <div
            class="border-2 border-dashed border-gray-200 rounded-2xl p-4 flex flex-col items-center justify-center gap-3 hover:border-blue-400 transition-all bg-gray-50"
          >
            <p-fileupload
              mode="basic"
              [name]="question.id + '_front'"
              [auto]="true"
              (onSelect)="onFileUpload($event, 'front')"
              chooseLabel="Upload Front"
              styleClass="p-button-sm p-button-outlined"
            ></p-fileupload>
            <div *ngIf="control?.value?.front" class="text-xs text-green-600 font-medium">
              ✓ Uploaded {{ control?.value?.front?.name }}
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-3">
          <span class="text-xs font-bold text-gray-500 uppercase text-center">Left Profile</span>
          <div
            class="border-2 border-dashed border-gray-200 rounded-2xl p-4 flex flex-col items-center justify-center gap-3 hover:border-blue-400 transition-all bg-gray-50"
          >
            <p-fileupload
              mode="basic"
              [name]="question.id + '_left'"
              [auto]="true"
              (onSelect)="onFileUpload($event, 'left')"
              chooseLabel="Upload Left"
              styleClass="p-button-sm p-button-outlined"
            ></p-fileupload>
            <div *ngIf="control?.value?.left" class="text-xs text-green-600 font-medium">
              ✓ Uploaded {{ control?.value?.left?.name }}
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-3">
          <span class="text-xs font-bold text-gray-500 uppercase text-center">Right Profile</span>
          <div
            class="border-2 border-dashed border-gray-200 rounded-2xl p-4 flex flex-col items-center justify-center gap-3 hover:border-blue-400 transition-all bg-gray-50"
          >
            <p-fileupload
              mode="basic"
              [name]="question.id + '_right'"
              [auto]="true"
              (onSelect)="onFileUpload($event, 'right')"
              chooseLabel="Upload Right"
              styleClass="p-button-sm p-button-outlined"
            ></p-fileupload>
            <div *ngIf="control?.value?.right" class="text-xs text-green-600 font-medium">
              ✓ Uploaded {{ control?.value?.right?.name }}
            </div>
          </div>
        </div>
      </div>

      <!-- Special Template: Health Report (Optional Upload) -->
      <!-- <div *ngIf="question.template_type === QuestionTemplate.HealthReport" class="mt-4">
        <label class="text-sm font-semibold text-gray-700 block mb-3">Upload your latest health report (PDF/Images)</label>
        <div class="border-2 border-dashed border-gray-200 rounded-2xl p-8 flex flex-col items-center justify-center gap-4 hover:border-blue-400 transition-all bg-gray-50 group">
          <div class="w-16 h-16 bg-blue-50 text-blue-600 rounded-full flex items-center justify-center text-2xl group-hover:scale-110 transition-transform">
             <i class="pi pi-cloud-upload"></i>
          </div>
          <div class="text-center">
            <p-fileupload mode="basic" [name]="question.id" [auto]="true" [multiple]="true" (onSelect)="onHealthReportUpload($event)"
                          chooseLabel="Choose Health Report" styleClass="p-button-primary shadow-md"></p-fileupload>
            <p class="text-xs text-gray-500 mt-2 font-medium">Accepts PDF and Images (Converted to PDF)</p>
          </div>
          <div *ngIf="control?.value" class="w-full mt-4 p-3 bg-green-50 border border-green-100 rounded-xl flex items-center justify-between">
            <div class="flex items-center gap-2">
              <i class="pi pi-check-circle text-green-600"></i>
              <span class="text-xs font-semibold text-green-700 truncate max-w-[200px]">Report Uploaded Successully</span>
            </div>
            <a [href]="control?.value" target="_blank" class="text-xs text-blue-600 font-bold hover:underline cursor-pointer">View Report</a>
          </div>
        </div>
      </div> -->

      <!-- Fallback Switch for other types when template is not a primary layout/special -->
      <div
        *ngIf="
          question.template_type !== QuestionTemplate.BmiCalculation &&
          question.template_type !== QuestionTemplate.Grid &&
          question.template_type !== QuestionTemplate.List_View &&
          question.template_type !== QuestionTemplate.Chip_Choice &&
          question.template_type !== QuestionTemplate.Sleep_Input &&
          question.template_type !== QuestionTemplate.FullBodyImage &&
          question.template_type !== QuestionTemplate.HealthReport &&
          question.template_type !== QuestionTemplate.Yes_No &&
          question.template_type !== QuestionTemplate.DietryRecall
        "
        [ngSwitch]="question.question_type"
      >
        <!-- Text -->
        <div *ngSwitchCase="QuestionType.Text">
          <input
            *ngIf="question.template_type !== QuestionTemplate.Text_Input"
            pInputText
            [formControlName]="question.id"
            [placeholder]="question.placeholder || ''"
            class="w-full"
          />
          <textarea
            *ngIf="question.template_type === QuestionTemplate.Text_Input"
            pInputTextarea
            [formControlName]="question.id"
            [placeholder]="question.placeholder || ''"
            class="w-full"
            rows="6"
          ></textarea>
        </div>

        <!-- File Upload -->
        <div *ngSwitchCase="QuestionType.File_Upload">
          <p-fileupload
            mode="basic"
            [name]="question.id"
            [auto]="true"
            [maxFileSize]="(question.max_file_size_mb || 5) * 1000000"
            (onUpload)="onFileUpload($event)"
            chooseLabel="Upload File"
            styleClass="p-button-outlined"
          ></p-fileupload>
        </div>

        <!-- Progress Bar -->
        <div *ngSwitchCase="QuestionType.Progress_Bar" class="px-2 py-4">
          <p-slider
            [formControlName]="question.id"
            [min]="0"
            [max]="question.progress_bar_max || 100"
            [step]="question.step || 1"
          ></p-slider>
          <div class="flex justify-between mt-2 text-xs text-gray-400">
            <span>0</span>
            <span>{{ control?.value || 0 }}</span>
            <span>{{ question.progress_bar_max || 100 }}</span>
          </div>
        </div>

        <!-- Date -->
        <div *ngSwitchCase="QuestionType.Date">
          <p-datepicker
            [formControlName]="question.id"
            [showIcon]="true"
            class="w-full"
            appendTo="body"
          ></p-datepicker>
        </div>

        <!-- Number -->
        <div *ngSwitchCase="QuestionType.Number">
          <p-inputnumber
            [formControlName]="question.id"
            [placeholder]="question.placeholder || ''"
            class="w-full"
          ></p-inputnumber>
        </div>
      </div>

      <!-- Dietary Recall (Structured UI) -->
      <div
        *ngIf="
          question.question_type === QuestionType.Dietry_Recall ||
          question.template_type === QuestionTemplate.DietryRecall
        "
        class="flex flex-col gap-6"
      >
        <div
          *ngFor="let meal of dietaryMeals; let mIndex = index"
          class="bg-card rounded-[24px] p-5 shadow-sm border border-foreground/20"
        >
          <!-- Meal Header -->
          <div class="flex items-start gap-4 mb-4">
            <div
              class="text-3xl bg-white rounded-full p-2 h-12 w-12 flex items-center justify-center"
            >
              {{ meal.icon }}
            </div>
            <div class="flex flex-col">
              <span class="text-foreground text-lg font-bold">{{ meal.title }}</span>
              <span class="text-gray-400 text-sm">{{ meal.example }}</span>
            </div>
          </div>

          <!-- Entries List -->
          <div class="flex flex-col gap-4">
            <div
              *ngFor="let entry of meal.entries; let eIndex = index"
              class="rounded-2xl p-4 bg-card shadow-xl"
            >
              <!-- Remove Entry Button (if more than 1) -->
              <div *ngIf="meal.entries.length > 1" class="flex justify-end mb-2">
                <button
                  type="button"
                  (click)="removeDietaryEntry(mIndex, eIndex)"
                  class="text-red-400 hover:text-red-300 text-sm flex items-center gap-1"
                >
                  <i class="pi pi-times-circle"></i> Remove
                </button>
              </div>

              <div class="mb-4">
                <label class="block text-foreground text-sm font-medium mb-2"
                  >What time do you eat?</label
                >
                <div class="flex items-center gap-4">
                  <p-dropdown
                    [options]="timeOptions"
                    [(ngModel)]="entry.startTime"
                    [ngModelOptions]="{ standalone: true }"
                    (onChange)="updateDietaryRecall()"
                    placeholder="Start Time"
                    styleClass="w-full "
                    [appendTo]="'body'"
                  >
                  </p-dropdown>
                  <span class="text-gray-500 font-bold">—</span>
                  <p-dropdown
                    [options]="timeOptions"
                    [(ngModel)]="entry.endTime"
                    [ngModelOptions]="{ standalone: true }"
                    (onChange)="updateDietaryRecall()"
                    placeholder="End Time"
                    styleClass="w-full "
                    [appendTo]="'body'"
                  >
                  </p-dropdown>
                </div>
              </div>

              <div>
                <label class="block text-foreground text-sm font-medium mb-2"
                  >What did you eat?</label
                >
                <textarea
                  pInputTextarea
                  [(ngModel)]="entry.details"
                  [ngModelOptions]="{ standalone: true }"
                  (input)="updateDietaryRecall()"
                  [placeholder]="'E.g., 2 rotis + sabzi (1 bowl)...'"
                  class="w-full"
                  rows="3"
                ></textarea>
              </div>
            </div>
          </div>

          <!-- Add Another Time Button -->
          <button
            type="button"
            (click)="addDietaryEntry(mIndex)"
            class="mt-4 flex items-center gap-2 text-blue-500 hover:text-blue-400 font-medium text-sm px-4 py-2 border border-blue-500/30 rounded-full hover:bg-blue-500/10 transition-colors"
          >
            <i class="pi pi-plus"></i> Add Another Time
          </button>
        </div>
      </div>
    </div>

    <!-- Error Message -->
    <div
      *ngIf="control?.invalid && (control?.dirty || control?.touched)"
      class="mt-2 text-xs text-red-500"
    >
      <span *ngIf="control?.errors?.['required']">This field is required.</span>
    </div>
  </div>

  <!-- Recursive Children -->
  <div *ngFor="let child of childQuestions" class="mt-4">
    <app-dynamic-question
      [question]="child"
      [form]="form"
      [allQuestions]="allQuestions"
      [level]="level + 1"
      [patientDetails]="patientDetails"
    ></app-dynamic-question>
  </div>
</div>
